import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto, Alert } from '../../../js/ComponentManager'

/* 개발담당:양유빈
 * 화면기능:라이브챗 주문서
 * 세부설명:
*/

export class LiveChatOrder extends Component {
    static displayName = LiveChatOrder.name;

    constructor(props) {
        super(props);
        this.state = {
            ChatOrderList: [],
            SelectOrdgrp_No: 0,
        };
        this.CsName = Big3Common.ContentState;
        this.Union_Uid = "";
        if (this.props.ContentState !== undefined) {
            this.Union_Uid = this.props.ContentState[this.CsName.Union_Uid] !== undefined ? this.props.ContentState[this.CsName.Union_Uid] : "";
        }

        this.handleSelectOrder_Click = this.handleSelectOrder_Click.bind(this);
        this.handleSend_Click = this.handleSend_Click.bind(this);

    }
    //초기화
    componentDidMount() {
        this.CallLiveChatOrderData();
    }
    handleSelectOrder_Click = (event, Ordgrp_No) => {
        this.setState({ SelectOrdgrp_No: Ordgrp_No });
        event.preventDefault();
    }
    //선택주문번호 전송
    handleSend_Click = (event) => {
        if (this.state.SelectOrdgrp_No === 0) {
            Big3Common.ModalAlert(bootstrap, 'LiveChatOrderAlert');
            return false;
        }
        const ContentState = this.props.ContentState;
        ContentState.SelectOrdgrp_No = this.state.SelectOrdgrp_No;
        this.props.RenderComponent("LiveChatDig", ContentState);
        event.preventDefault();
    }
    //주문문의 조회
    async CallLiveChatOrderData() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Order/LiveChat/GetSearchOrderList', {
                union_uid: this.Union_Uid
            });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let ChatOrderList = JSON.parse(Data.dataTable);
                this.setState({
                    ChatOrderList: ChatOrderList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallLiveChatOrderData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }

    Listrender() {
        const ChatOrderList = this.state.ChatOrderList;
        return (
            <>
                {ChatOrderList.map((list, idx) =>
                    <div className="chat_order_box" key={idx} >
                        <div className="check_box" onClick={(e) => { this.handleSelectOrder_Click(e, list.ordgrp_no) }}>
                            <input type="radio" name="goods" />
                        </div>
                        <div className="chat_order_date">{list.ord_dt}</div>
                        <div className="chat_order_info_box">
                            <GoodsPhoto className="order_img" ImageSrc={list.img_220} />
                            <div className="order_info">
                                <div className="good_name">{list.goodsnm_count}</div>
                                <div className="good_name">{Big3Common.Util.Money(list.totalprice)}원</div>
                            </div>
                        </div>
                        <div className="chat_order_type">{list.ord_type}</div>
                        {list.ord_status === "JM" ? (
                            <div className="order_status_p">거래중</div>
                        ) : (
                            <div className="order_status_f">거래완료</div>
                        )}
                    </div>
                )}
            </>
        )
    }
    render() {
        let Listrender = this.Listrender();
        return (
            <>
                <div className="container_box p_margin u_padding">
                    {Listrender}
                </div>
                <div className="p_send_btn_box" onClick={(e) => { this.handleSend_Click(e) }}>
                    <div>선택전송</div>
                    <p></p>
                </div>
                <Alert
                    id="LiveChatOrderAlert"
                    content=""
                    title="주문서를 선택하세요."
                />
            </>
        );

    }
}
